/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getInvoiceAuditLog } from "api/services/invoice";
import { invoiceQueryKeys } from "./invoiceQueryKeys";

type GetInvoiceAuditLogOptions = {
  invoiceId: string;
  options?: UseQueryOptions;
  queryFn?: any;
};

export const useGetInvoiceAuditLog = (data: GetInvoiceAuditLogOptions) =>
  useQuery({
    queryKey: invoiceQueryKeys.invoiceAuditListing(data.invoiceId),
    queryFn: data.queryFn
      ? data.queryFn
      : () => getInvoiceAuditLog(data.invoiceId).then((res) => res.data.results.reverse()),
    ...data.options,
  });
